export const AMOUNT_OPTIONS = [
    {
        "id":1,
        "name":"$20.00 pesos",
        "amount":20.00
    },
    {
        "id":2,
        "name":"$50.00 pesos",
        "amount":50.00
    },
    {
        "id":3,
        "name":"$100.00 pesos",
        "amount":100.00
    },
    {
        "id":4,
        "name":"$300.00 pesos",
        "amount":300.00
    },
    {
        "id":5,
        "name":"$500.00 pesos",
        "amount":500.00
    },
    {
        "id":6,
        "name":"$1000.00 pesos",
        "amount":1000.00
    },
    {
        "id":9999,
        "name":"Otra cantidad",
        "amount":0
    }
]
export const MONTH_OPTIONS = [
    {
        "id":1,
        "name":"01"
    },
    {
        "id":2,
        "name":"02"
    },
    {
        "id":3,
        "name":"03"
    },
    {
        "id":4,
        "name":"04"
    },
    {
        "id":5,
        "name":"05"
    },
    {
        "id":6,
        "name":"06"
    },
    {
        "id":7,
        "name":"07"
    },
    {
        "id":8,
        "name":"08"
    },
    {
        "id":9,
        "name":"09"
    },
    {
        "id":10,
        "name":"10"
    },
    {
        "id":11,
        "name":"11"
    },
    {
        "id":12,
        "name":"12"
    }
]